import initialState from './initialState';
import {SET_USER} from '../actions/UserActions';

export default function UserReducer(state = initialState.user, action) {
    switch (action.type) {
        case SET_USER:
            const {data} = action.payload;
            return {...data};
        default:
            return state;
    }
}
